<template>
  <Dialog
    :header="`Excluir ${type}`"
    :style="{ minWidth: '400px' }"
    :modal="true"
    :visible="visible"
    @update:visible="$emit('cancel')"
  >
    <div class="confirmation-content">
      <i
        class="pi pi-exclamation-triangle p-mt-1 p-mr-3"
        style="font-size: 2rem"
      />
      <span class="p-mt-1">
        Realmente deseja excluir
        <b>{{ item }}</b>
        ?
      </span>
    </div>
    <template #footer>
      <Button
        label="Cancelar"
        class="p-button-outlined"
        @click="$emit('cancel')"
      />
      <Button
        label="Excluir"
        class="p-button-danger"
        @click="$emit('confirm')"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'AppModalDelete',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    item: {
      type: String,
      required: true,
    },
    // error: {
    //   type: String,
    //   required: true,
    // },
    // loading: {
    //   type: Boolean,
    //   required: true,
    // },
  },
};
</script>

<style scoped>
.confirmation-content {
  display: flex;
  align-items: center;
}
</style>
